// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogCard_card__aHV9a","btn":"BlogCard_btn__1AiBu","extra":"BlogCard_extra__3-hw9"};